import { Intent } from '@blueprintjs/core';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { server as StardogServer } from 'stardog';
import {
  BaseConnection,
  exportBlobToFile,
  getStardogConnection,
} from 'vet-bones/utils';

import { useAppDispatch } from 'src/ui/app/hooks';
import { queueMessage } from 'src/ui/features/notifications';
import { Connection } from 'src/ui/graph/types';
import { runWithRefetchConnectionToken } from 'src/ui/hooks/refetchConnectionToken';

export const useDownloadLogs = (connection: Connection) => {
  const { org = '' } = useParams<{ org?: string }>();
  const dispatch = useAppDispatch();
  return React.useCallback(async () => {
    try {
      dispatch(
        queueMessage({
          message: `Downloading logs for "${connection.name}", this may take a while.`,
          intent: Intent.NONE,
        })
      );

      const stardogConnection = getStardogConnection(
        connection as BaseConnection,
        { agent: 'Portal' }
      );

      const response = await runWithRefetchConnectionToken(
        org
      )(stardogConnection, connection.index, (stardogConn) =>
        StardogServer.logs(stardogConn)
      );

      if (!response.ok) {
        throw new Error('Failed to download logs.');
      }

      exportBlobToFile({
        blob: await response.blob(),
        filename: `logs-${connection.name}.zip`,
      });
    } catch (error) {
      console.error(error);

      dispatch(
        queueMessage({
          message: `Failed to download logs for "${connection.name}".`,
          intent: Intent.DANGER,
        })
      );
    }
  }, [connection, dispatch, org]);
};
